import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ContentChildren,
    ElementRef,
    Input,
    OnDestroy,
    QueryList,
    ViewChild,
    ViewChildren
} from '@angular/core';
import { CarouselItemDirective } from '@app/main/home/directives/carousel-item.directive';
import { animate, AnimationBuilder, AnimationFactory, AnimationPlayer, style } from '@angular/animations';
import { CarouselItemElementDirective } from '@app/main/home/directives/carousel-item-element.directive';
import { IItemBase } from '@shared/interfaces';

@Component({
    selector: 'app-home-carousel',
    templateUrl: './home-carousel.component.html',
    styleUrls: ['./home-carousel.component.scss'],
    standalone: false
})
export class HomeCarouselComponent implements AfterViewInit, OnDestroy {
    @ContentChildren(CarouselItemDirective) items: QueryList<CarouselItemDirective>;
    @Input() timing = '250ms ease-in';
    @Input() showControls = true;
    @Input() auto = false;
    @Input() delay = 0;
    @Input() controlColor: string;
    @Input() disabled: boolean;
    public currentSlide = 0;
    carouselInnerStyle = {};
    public timeInterval;
    public timeout;
    @ViewChildren(CarouselItemElementDirective, { read: ElementRef }) readonly itemsElements: QueryList<ElementRef>;
    @ViewChild('carousel') private carousel: ElementRef;
    @ViewChild('carouselWrapper') private carouselWrapper: ElementRef;
    private player: AnimationPlayer;
    private itemWidth: number;
    private currentDirection = 'next';

    constructor(
        private builder: AnimationBuilder,
        private changeDetection: ChangeDetectorRef
    ) {}

    private _itemList: IItemBase[];

    @Input() set itemList(items: IItemBase[]) {
        this._itemList = items;
        if (this.carouselWrapper && (items?.length || 1) !== this.itemsElements.length) {
            this.itemWidth = this.carouselWrapper.nativeElement.getBoundingClientRect().width;
            this.carouselInnerStyle = {
                width: `${this.itemWidth * (items.length || 1)}px`
            };
        }
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.itemWidth = this.carouselWrapper.nativeElement.getBoundingClientRect().width;
            this.carouselInnerStyle = {
                width: `${this.itemWidth * (this.itemsElements.length || 1)}px`
            };

            if (this.auto && this.itemsElements.length > 1) {
                this.timeout = setTimeout(() => {
                    this.timeInterval = setInterval(() => {
                        if (this.currentDirection === 'next') {
                            this.next();
                        } else {
                            this.prev();
                        }
                    }, 3500);
                }, this.delay);
            }
        });
    }

    ngOnDestroy(): void {
        this.stopTimeInterval();
    }

    next() {
        if (this.currentSlide + 1 === this.items.length || this.itemsElements.length <= 1) {
            this.currentDirection = 'prev';
            return;
        }
        this.currentSlide = (this.currentSlide + 1) % this.items.length;
        const offset = this.currentSlide * this.itemWidth;

        if (this.carousel.nativeElement) {
            try {
                const myAnimation: AnimationFactory = this.buildAnimation(offset);
                this.player = myAnimation.create(this.carousel.nativeElement);
                this.player.play();
            } catch (e) {
                console.error(e);
            }
        }
    }

    prev() {
        if (this.currentSlide === 0 || this.itemsElements.length <= 1) {
            this.currentDirection = 'next';
            return;
        }

        this.currentSlide = (this.currentSlide - 1 + this.items.length) % this.items.length;
        const offset = this.currentSlide * this.itemWidth;

        if (this.carousel.nativeElement) {
            const myAnimation: AnimationFactory = this.buildAnimation(offset);
            this.player = myAnimation.create(this.carousel.nativeElement);
            this.player.play();
        }
    }

    public stopTimeInterval() {
        clearInterval(this.timeInterval);
        clearTimeout(this.timeout);
    }

    private buildAnimation(offset) {
        return this.builder.build([animate(this.timing, style({ transform: `translateX(-${offset}px)` }))]);
    }
}
